import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconStoreRepair from '@/icons/StoreRepair.svg';

import { useFilters } from '../FiltersState';

export const MobileFiltersArticleWorkshop = () => {
  const { t } = useLingui();

  const {
    articleWorkshopSelections: { articleWorkshopSelections, setArticleWorkshopSelections },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="article-workshop"
      selectedEntities={articleWorkshopSelections}
      setSelectedEntities={setArticleWorkshopSelections}
      traits={['workshop']}
      label={t({
        id: 'settings.organization.entities.agreements.filters.article_workshop.label',
        message: 'Article workshop',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.entities.agreements.filters.article_workshop.search',
        message: 'Search workshops',
      })}
      icon={<IconStoreRepair />}
    />
  );
};
